import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { AiOutlineUserDelete } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { BsDash } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { API_URL } from "../../config";
import { logAuditUI } from "../../utils/auditLogger";

function DashboardCard16() {
  const { showToast } = useToast();
  const [open1, setOpen1] = useState(false);
  const [open, setOpen] = useState(false);
  const [selecteduser, setSelecteduser] = useState(null);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [data, setData] = useState([]);
  const [Nume_prenume, setNume_prenume] = useState("");
  const [user, setUser] = useState(null);
  const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
  const [defaultOption, setDefaultOption] = useState("");  // Default value should be role_id
  const [Rol, setRol] = useState([]);
  const [roleError, setRoleError] = useState(false);
  const [nameError, setnameError] = useState(false);
  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };
  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');


  useEffect(() => {
    axios
      .get(`${API_URL}/api/region`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setRol(response.data);
        // //////////////////////////////console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);

    // Cleanup pentru timer
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);  // decoded is the correct variable here
        setUser(decoded); // Store decoded user data
        ////////////////////////////////console.log(user)
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  const fetchManageData = () => {
    axios
      .get(`${API_URL}/api/district`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        logAuditUI({
          actionType: 'VIEW_LIST',
          module: 'Raioane/Regiuni',
          entityType: 'district',
          description: 'A accesat lista de raioane',
          details: { count: Array.isArray(response.data) ? response.data.length : 0 },
        });
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  useEffect(() => {
    fetchManageData();
  }, []);

  const itemsPerPage = 16;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const currentItems = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (selecteddeleteuser) {
      //////////////////////////////console.log("Selected user to delete:", selecteddeleteuser);  // Aici poți verifica ce conține userul selectat
      deleteRow();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser) {
      //////////////////////////////console.log("Selected user to delete:", selecteduser);  // Aici poți verifica ce conține userul selectat
      handleOpenProd1();
    }
  }, [selecteduser]);

  const deleteRow = async () => {

    try {
      await axios.put(
        `${API_URL}/api/deletedistrict`,
        {
          district_id: selecteddeleteuser.district_id,

        }
      );
      fetchManageData();
      showToast({
        message: "Datele au fost sterse cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      // console.error("Error saving changes:", error);
      showToast({
        message: "Eroare la ștergerea datelor! \nEste posibil ca datele să fie utilizate și de aceea nu se poate efectua ștergerea.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleSave = async () => {
    if (!Nume_prenume.trim()) {
      setnameError(Nume_prenume === "" ? true : false)

      showToast({
        message: "Denumirea nu poate fi goală!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      return;
    }
    if (!['1', '2', '3'].includes(defaultOption)) {
      setRoleError(true); // Setează eroarea
      //////////////////////////////console.log('oprit');
      return; // Oprește execuția formularului
    }


    try {
      await axios.post(`${API_URL}/api/district`, {
        district_name: Nume_prenume,
        region_id: defaultOption
      });
      fetchManageData();
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
      setOpen(false);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleEdit = async () => {
    try {
      await axios.put(`${API_URL}/api/changedistrict/${selecteduser.district_id}`, {
        district_name: Nume_prenume,
        region_id: defaultOption

      });
      fetchManageData();
      setOpen1(false);
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleOpenProd1 = () => {
    setOpen1(true); // Deschide dialogul
    setNume_prenume(selecteduser.district_name);
    setDefaultOption(selecteduser.region_id);
    setRoleError(false); // Setează eroarea
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raioane/Regiuni',
      entityType: 'district',
      entityId: selecteduser?.district_id,
      entityName: selecteduser?.district_name,
      description: `A deschis formularul de editare raion: ${selecteduser?.district_name || selecteduser?.district_id || ''}`,
    });
  };

  const handleOpenRows = () => {
    setDefaultOption("");
    setNume_prenume("");
    setOpen(true); // Deschide dialogul
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raioane/Regiuni',
      entityType: 'district',
      description: 'A deschis formularul de adăugare raion nou',
    });
  };

  const handleChange = (e) => {
    setNume_prenume(e.target.value);
  };

  const dropdownOptions = Rol.map((region) => ({
    value: region.region_id,
    label: region.region_name
  }));

  const _onSelect = (selectedOption) => {
    //////////////////////////////console.log(selectedOption);
    setDefaultOption(selectedOption);  // Set the selected option
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
            <h2 className="font-bold text-gray-800 dark:text-gray-100">Raioane</h2>
            {user?.role === "Admin" && (<button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
              onClick={handleOpenRows}
            >
              <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              <span className="//max-xs:sr-only">Adauga</span>

              <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                            Adauga Raion
                          </Dialog.Title>
                          <div className=" max-h-64 overflow-y-auto">
                            <div className="relative mt-5">
                              <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                                Denumirea
                              </label>
                              <input
                                className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${nameError ? 'border-red-500' : ''}`}
                                type="text"
                                name="firstName"
                                placeholder="Denumirea"
                                value={Nume_prenume}
                                onChange={handleChange}
                                required
                              />
                              {nameError && <p className="text-red-500 text-sm">Numele este obligatoriu.</p>}
                            </div>

                            <div className="relative mt-4">
                              <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Regiunea</label>
                              <select
                                className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${roleError ? 'border-red-500' : ''}`}  // Adaugă clasa pentru eroare
                                value={defaultOption}
                                onChange={(e) => _onSelect(e.target.value)}
                              >
                                <option value="" disabled>Alege regiunea</option>
                                {dropdownOptions.map((option) => (
                                  <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                              </select>
                              {roleError && <p className="text-red-500 text-sm">Regiunea este obligatoriu.</p>}
                            </div>
                          </div>
                          <div className="mt-4 flex justify-end gap-2">
                            <button
                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                              onClick={() => setOpen(false)}
                            >
                              Anulează
                            </button>
                            <button
                              className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-900 dark:bg-gray-200 dark:text-gray-700"
                              onClick={handleSave}
                            >
                              Salvează
                            </button>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition>
            </button>
            )}

            <Transition appear show={open1} as={Fragment}>
              <Dialog as="div" className="relative z-10" onClose={() => setOpen1(false)}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                  <div className="flex min-h-full items-center justify-center p-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                        <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                          Editeaza Raion
                        </Dialog.Title>
                        <div className=" max-h-64 overflow-y-auto">
                          <div className="relative mt-5">
                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                              Denumirea
                            </label>
                            <input
                              className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                              type="text"
                              placeholder="Denumirea"
                              value={Nume_prenume}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="relative mt-4">
                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Regiunea</label>
                            <select
                              className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${roleError ? 'border-red-500' : ''}`}  // Adaugă clasa pentru eroare
                              value={defaultOption}
                              onChange={(e) => _onSelect(e.target.value)}
                            >
                              <option value="" disabled>Alege regiunea</option>
                              {dropdownOptions.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </select>
                            {roleError && <p className="text-red-500 text-sm">Regiunea este obligatoriu.</p>}
                          </div>
                        </div>
                        <div className="mt-4 flex justify-end gap-2">
                          <button
                            className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                            onClick={() => setOpen1(false)}
                          >
                            Anulează
                          </button>
                          <button
                            className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-900 dark:bg-gray-200 dark:text-gray-700"
                            onClick={handleEdit}
                          >
                            Salvează
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
          </header>

          <div className="p-3" >
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="table-auto w-full dark:text-gray-300">
                {/* Table header */}
                <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-left">Denumirea</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Regiunea</div>
                    </th>

                    <th className="p-2">
                      <div className="font-semibold text-center">Actiune</div>
                    </th>
                  </tr>
                </thead>
                {/* Table body */}
                <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                  {currentItems.map((customer, index) => {
                    return (
                      <tr
                        role="button"
                        key={customer.district_id}
                        className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"
                          } hover:bg-gray-200 dark:hover:bg-gray-600`}
                      >
                        <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser(customer)}>
                          <div className="text-left">{customer.district_name}</div>
                        </td>
                        <td className="p-2 whitespace-nowrap" onClick={() => setSelecteduser(customer)}>
                          <div className="text-left">{customer.region_name}</div>
                        </td>
                        <td>
                          <div className="font-semibold text-center"
                            style={{
                              fontWeight: "bold",
                              fontSize: "20px"
                            }}
                          >
                            <IconButton
                              onClick={() => setSelecteduser(customer)}
                              color="primary"
                              sx={{
                                fontSize: "16px",
                                borderRadius: "50%",
                                "&:hover": {
                                  backgroundColor: "#a4adad",
                                },
                              }}
                            >
                              < AiFillEdit className=" dark:text-gray-100" />
                            </IconButton>

                            <IconButton
                              onClick={() => setSelecteddeleteuser(customer)}
                              color="primary"
                              sx={{
                                fontSize: "16px",
                                borderRadius: "50%",
                                "&:hover": {
                                  backgroundColor: "#a4adad",
                                },
                              }}
                            >
                              <AiOutlineDelete className=" dark:text-gray-100" />
                            </IconButton>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === 1}
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={`px-4 py-2 text-sm font-medium ${currentPage === index + 1
                    ? "bg-gray-500 text-white"
                    : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                    }`}
                >
                  {index + 1}
                </button>
              ))}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>

          </div>

        </div>
      )}</div>
  );
}

export default DashboardCard16;
